import { render, staticRenderFns } from "./SocialTab.vue?vue&type=template&id=2eaa979f&scoped=true"
import script from "./SocialTab.vue?vue&type=script&lang=js"
export * from "./SocialTab.vue?vue&type=script&lang=js"
import style0 from "./SocialTab.vue?vue&type=style&index=0&id=2eaa979f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eaa979f",
  null
  
)

export default component.exports